export function isFileValid(file: File, accept?: string) {
  if (!accept) {
    return true;
  }

  const types = accept.split(',');

  return types.some((type) => {
    const [mime, extension] = type.split('/');
    if (mime.startsWith('.')) {
      return file.name.endsWith(mime);
    } else if (extension === '*') {
      return file.type.startsWith(mime);
    } else {
      return file.type === type;
    }
  });
}
